var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.classes,on:{"click":function($event){return _vm.$emit('click', _vm.tab)}}},[_vm._t("icon"),_vm._v(" "+_vm._s(_vm.text)+" ")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }